__turbopack_context__.v({
  "logo": "_3gauRq_logo",
});
